import { DRAWER_FRONT_H, topDrawers, bayWidths, ripado, anyTamp } from "../lib/modules";
import { outlinePath } from "../lib/pieces";

const WOOD = "#CA7C38";
const FACE = "#2A2F3A";
const PANEL = "#323846";
const ACC = "#E67E22";

function Box({ W, H, D, children }) {
  const dx = D * 0.35, dy = D * 0.25;
  return (
    <g>
      <polygon points={`0,0 ${dx},${-dy} ${W + dx},${-dy} ${W},0`} fill="#3A3226" stroke={WOOD} strokeWidth={4} />
      <polygon points={`${W},0 ${W + dx},${-dy} ${W + dx},${H - dy} ${W},${H}`} fill="#2B251C" stroke={WOOD} strokeWidth={4} />
      <rect x={0} y={0} width={W} height={H} fill={FACE} stroke={WOOD} strokeWidth={5} />
      {children}
    </g>
  );
}

function Doors({ W, H, n }) {
  const dw = (W - 8 - (n - 1) * 3) / n;
  return Array.from({ length: n }, (_, i) => {
    const x = 4 + i * (dw + 3);
    const hx = i % 2 === 0 && i < n - 1 ? x + dw - 30 : x + 30;
    return (
      <g key={i}>
        <rect x={x} y={4} width={dw} height={H - 8} fill={PANEL} stroke={ACC} strokeWidth={3} />
        <rect x={hx - 4} y={H / 2 - 40} width={8} height={80} rx={4} fill="#9CA3AF" />
      </g>
    );
  });
}

function Sliding({ W, H, n }) {
  const dw = (W - 36 + (n - 1) * 40) / n;
  return (
    <g>
      <rect x={18} y={18} width={W - 36} height={10} fill="#6B7280" />
      <rect x={18} y={H - 28} width={W - 36} height={10} fill="#6B7280" />
      {Array.from({ length: n }, (_, i) => (
        <rect key={i} x={18 + i * (dw - 40)} y={30} width={dw} height={H - 60} fill={i % 2 ? "#3A4150" : PANEL} stroke={ACC} strokeWidth={4} opacity={0.95} />
      ))}
    </g>
  );
}

function Drawers({ W, H, n }) {
  const fh = (H - 8 - (n - 1) * 3) / n;
  return Array.from({ length: n }, (_, i) => {
    const y = 4 + i * (fh + 3);
    return (
      <g key={i}>
        <rect x={4} y={y} width={W - 8} height={fh} fill={PANEL} stroke={ACC} strokeWidth={3} />
        <rect x={W / 2 - 50} y={y + Math.min(30, fh / 3)} width={100} height={8} rx={4} fill="#9CA3AF" />
      </g>
    );
  });
}

function Shelves({ W, H, n, T = 18 }) {
  const inner = H - 2 * T;
  return Array.from({ length: n }, (_, i) => {
    const y = T + ((i + 1) * inner) / (n + 1);
    return <rect key={i} x={T} y={y - T / 2} width={W - 2 * T} height={T} fill={WOOD} opacity={0.9} />;
  });
}

function Dim({ W, H, D, box }) {
  const f = Math.max(W, H) / 22;
  const bw = box && box.W !== W ? ` (caixa ${box.W})` : "", bh = box && box.H !== H ? ` (caixa ${box.H})` : "";
  return (
    <g fontFamily="JetBrains Mono, monospace" fontSize={f} fill="#00E5FF">
      <line x1={0} y1={H + f * 1.2} x2={W} y2={H + f * 1.2} stroke="#00E5FF" strokeWidth={Math.max(2, f / 12)} />
      <text data-testid="dim-width" x={W / 2} y={H + f * 2.6} textAnchor="middle">{W}<tspan fill="#22D3EE" fontSize={f * 0.7}>{bw}</tspan></text>
      <line x1={-f * 1.2} y1={0} x2={-f * 1.2} y2={H} stroke="#00E5FF" strokeWidth={Math.max(2, f / 12)} />
      <text data-testid="dim-height" x={-f * 1.6} y={H / 2} textAnchor="middle" transform={`rotate(-90 ${-f * 1.6} ${H / 2})`}>{H}<tspan fill="#22D3EE" fontSize={f * 0.7}>{bh}</tspan></text>
      {D > 0 && <text x={W + D * 0.2} y={-D * 0.25 - f * 0.5} textAnchor="middle">P {D}</text>}
    </g>
  );
}

function LDims({ A, B, Da, Db, H, regua, box }) {
  const cx = (v, b) => (box && b !== v ? ` (caixa ${b})` : "");
  const f = Math.max(A, B) / 22, sw = Math.max(2, f / 12), c = "#00E5FF";
  const hl = (x1, x2, y, t, id) => (
    <g data-testid={id}>
      <line x1={x1} y1={y} x2={x2} y2={y} stroke={c} strokeWidth={sw} />
      <line x1={x1} y1={y - f / 3} x2={x1} y2={y + f / 3} stroke={c} strokeWidth={sw} />
      <line x1={x2} y1={y - f / 3} x2={x2} y2={y + f / 3} stroke={c} strokeWidth={sw} />
      <text x={(x1 + x2) / 2} y={y - f * 0.35} textAnchor="middle">{t}</text>
    </g>
  );
  const vl = (y1, y2, x, t, id) => (
    <g data-testid={id}>
      <line x1={x} y1={y1} x2={x} y2={y2} stroke={c} strokeWidth={sw} />
      <line x1={x - f / 3} y1={y1} x2={x + f / 3} y2={y1} stroke={c} strokeWidth={sw} />
      <line x1={x - f / 3} y1={y2} x2={x + f / 3} y2={y2} stroke={c} strokeWidth={sw} />
      <text x={x - f * 0.35} y={(y1 + y2) / 2} textAnchor="middle" transform={`rotate(-90 ${x - f * 0.35} ${(y1 + y2) / 2})`}>{t}</text>
    </g>
  );
  return (
    <g fontFamily="JetBrains Mono, monospace" fontSize={f * 0.8} fill={c}>
      {hl(0, A, -f * 0.9, `Lado A ${A}${cx(A, box?.A)}`, "ldim-a")}
      {vl(0, B, -f * 0.9, `Lado B ${B}${cx(B, box?.B)}`, "ldim-b")}
      {vl(0, Da, A + f * 1.6, `P.A ${Da}`, "ldim-depth-a")}
      {hl(0, Db, B + f * 1.4, `P.B ${Db}`, "ldim-depth-b")}
      {hl(Db, A, Da + f * 1.4, `${A - Db}`, "ldim-inner-a")}
      {vl(Da, B, Db + f * 1.6, `${B - Da}`, "ldim-inner-b")}
      <text data-testid="ldim-height" x={Db + (A - Db) * 0.6} y={Da + (B - Da) * 0.55} textAnchor="middle" fill="#9CA3AF">Altura {H}{cx(H, box?.H)}</text>
      <text x={Db + (A - Db) * 0.6} y={Da + (B - Da) * 0.55 + f * 1.1} textAnchor="middle" fill="#E67E22" fontSize={f * 0.6}>■ régua vertical {regua}mm na quina</text>
    </g>
  );
}

// Interior with dividers, shelves and drawers per vão; doors drawn semi-transparent on top
function WardrobeOpen({ v, sliding, plain }) {
  const W = v.largura, H = v.altura, T = 18, inner = W - 2 * T;
  const ws = bayWidths(v, inner, T), cols = ws.length;
  const malY = plain ? 0 : T + Math.min(450, H * 0.18);
  const xs = ws.map((_, i) => T + ws.slice(0, i).reduce((a, c) => a + c, 0) + i * T);
  const af = sliding ? 0 : T;
  const bottom = H - (v.rodape_on ? v.rodape || 100 : 0) - (v.rodape_on ? 0 : T);
  return (
    <g data-testid="preview-wardrobe-open">
      <Box W={W} H={H} D={v.profundidade}>
        <rect x={T} y={T} width={inner} height={H - 2 * T} fill="#14110C" />
        {xs.slice(1).map((x, i) => <rect key={`d${i}`} data-testid="preview-divider" x={x - T} y={T} width={T} height={H - 2 * T} fill={WOOD} />)}
        {xs.map((x, c) => {
          const vao = ws[c], q = v[`prat_${c + 1}`] || 0, g = v[`gav_${c + 1}`] || 0, stack = g * (DRAWER_FRONT_H + 5);
          const low = g ? bottom - stack - T : bottom;
          return (
            <g key={c} data-testid={`preview-vao-${c + 1}`}>
              {!plain && <rect x={x} y={malY} width={vao} height={T} fill={WOOD} />}
              {(v[`div_${c + 1}`] || 0) > 0 && <rect data-testid="preview-inner-divider" x={x + vao / 2 - T / 2} y={Math.max(malY + T, bottom - v[`div_${c + 1}`])} width={T} height={Math.min(v[`div_${c + 1}`], bottom - malY - T)} fill={WOOD} />}
              {Array.from({ length: q }, (_, i) => (
                <rect key={i} data-testid="preview-shelf" x={x} y={malY + ((i + 1) * (low - malY)) / (q + 1)} width={vao} height={T} fill={WOOD} opacity={0.85} />
              ))}
              {g > 0 && (
                <g data-testid="preview-drawers">
                  <rect x={x} y={bottom - stack - T} width={vao} height={T} fill={WOOD} />
                  {af > 0 && [x, x + vao - af].map((ax) => <rect key={ax} data-testid="preview-spacer" x={ax} y={bottom - stack} width={af} height={stack} fill="#8B5A2B" />)}
                  {Array.from({ length: g }, (_, i) => (
                    <g key={i}>
                      <rect x={x + af + 2} y={bottom - stack + i * (DRAWER_FRONT_H + 5)} width={vao - 2 * af - 4} height={DRAWER_FRONT_H} fill={PANEL} stroke={ACC} strokeWidth={3} />
                      <line x1={x + vao / 2 - 40} y1={bottom - stack + i * (DRAWER_FRONT_H + 5) + 30} x2={x + vao / 2 + 40} y2={bottom - stack + i * (DRAWER_FRONT_H + 5) + 30} stroke={ACC} strokeWidth={6} />
                    </g>
                  ))}
                </g>
              )}
            </g>
          );
        })}
        <rect x={T} y={bottom} width={inner} height={Math.max(4, H - bottom - T)} fill="#2B251C" stroke={WOOD} strokeWidth={3} />
      </Box>
      {v.portas > 0 && (
        <g data-testid="preview-doors-transparent" opacity={0.3}>
          {sliding ? <Sliding W={W} H={H} n={v.portas} /> : <Doors W={W} H={H} n={v.portas} />}
        </g>
      )}
    </g>
  );
}

function Ripado({ v }) {
  const fundo = v.fundo, ripa = v.ripa;
  const { n, gap: esp, start, hz, H, W } = ripado(v);
  return (
    <g>
      {fundo ? <rect x={0} y={0} width={W} height={H} fill="#1C2028" stroke={WOOD} strokeWidth={4} /> : null}
      {Array.from({ length: n }, (_, i) => (hz
        ? <rect key={i} x={0} y={start + i * (ripa + esp)} width={W} height={ripa} fill={WOOD} stroke="#8A5225" strokeWidth={2} />
        : <rect key={i} x={start + i * (ripa + esp)} y={0} width={ripa} height={H} fill={WOOD} stroke="#8A5225" strokeWidth={2} />
      ))}
    </g>
  );
}

function Rounded({ L, W, r, corners }) {
  const d = outlinePath({ length: L, width: W, radius: r, corners }, (x, y) => [x, W - y]);
  return <path data-testid="preview-rounded" d={d} fill={PANEL} stroke={ACC} strokeWidth={Math.max(4, L / 150)} />;
}

function Sink({ W, D }) {
  return (
    <g>
      <rect x={-10} y={-D * 0.25 - 12} width={W + D * 0.35 + 20} height={12} fill="#E5E7EB" />
      <ellipse cx={W / 2 + D * 0.17} cy={-D * 0.12} rx={W * 0.25} ry={D * 0.09} fill="#9CA3AF" stroke="#E5E7EB" strokeWidth={3} />
    </g>
  );
}

function Scene({ kind, v }) {
  switch (kind) {
    case "aereo":
      return { W: v.largura, H: v.altura, D: v.profundidade, el: <WardrobeOpen v={v} plain /> };
    case "provencal": {
      const L = v.largura, H = v.altura, fw = Math.max(25, Math.min(v.moldura, Math.floor((Math.min(L, H) - 15) / 2)));
      return {
        W: L, H, D: v.espessura,
        el: <path data-testid="preview-provencal" fillRule="evenodd" d={`M0 0 H${L} V${H} H0 Z M${fw} ${fw} V${H - fw} H${L - fw} V${fw} Z`} fill={PANEL} stroke={ACC} strokeWidth={Math.max(3, Math.max(L, H) / 200)} />,
      };
    }
    case "espelheira":
      return { W: v.largura, H: v.altura, D: v.profundidade, el: <Box W={v.largura} H={v.altura} D={v.profundidade}>{v.portas > 0 && <Doors W={v.largura} H={v.altura} n={v.portas} />}</Box> };
    case "guarda_roupa":
      return { W: v.largura, H: v.altura, D: v.profundidade, el: <WardrobeOpen v={v} /> };
    case "correr":
      return { W: v.largura, H: v.altura, D: v.profundidade, el: <WardrobeOpen v={v} sliding /> };
    case "banheiro": {
      const W = v.largura, H = v.altura, pos = v.gaveta_pos === 0 && v.porta_tipo === 2 ? 2 : v.gaveta_pos, n = v.gaveta_pos === 0 ? 1 : v.gavetas;
      const side = pos > 2, gl = side ? Math.min(v.gaveta_largura, W - 250) : 0, st = pos === 1 || pos === 2 ? n * 154 : 0;
      return {
        W, H, D: v.profundidade,
        el: (
          <>
            <Box W={W} H={H} D={v.profundidade}>
              {st > 0 && <g data-testid="preview-bath-drawers" transform={`translate(0 ${pos === 1 ? 0 : H - st})`}><Drawers W={W} H={st} n={n} /></g>}
              {side && <g data-testid="preview-bath-drawers" transform={`translate(${pos === 3 ? 0 : W - gl} 0)`}><Drawers W={gl} H={H} n={n} /></g>}
              <g transform={`translate(${pos === 3 ? gl : 0} ${pos === 1 ? st : 0})`}><Doors W={W - gl} H={H - st} n={v.porta_tipo === 0 ? v.portas : 1} /></g>
            </Box>
            <Sink W={W} D={v.profundidade} />
          </>
        ),
      };
    }
    case "balcao_inferior": {
      const W = v.largura, H = v.altura, pos = v.gaveta_pos;
      const side = pos === 2 || pos === 3;
      const gl = side ? Math.min(v.gaveta_largura, W - 250) : 0;
      const n = pos === 1 ? topDrawers(H, v.gavetas) : 0;
      const fh = n ? n * 153 + 5 : 0;
      const dx = pos === 2 ? gl : 0;
      return {
        W, H, D: v.profundidade,
        el: (
          <>
            <rect x={-10} y={-v.profundidade * 0.25 - 14} width={W + v.profundidade * 0.35 + 20} height={14} fill="#6B7280" />
            <Box W={W} H={H} D={v.profundidade}>
              {n > 0 && <Drawers W={W} H={fh} n={n} />}
              {side && <g data-testid="preview-drawer-column" transform={`translate(${pos === 2 ? 0 : W - gl} 0)`}><Drawers W={gl} H={H} n={v.gavetas} /></g>}
              <g transform={`translate(${dx} ${fh})`}><Doors W={W - gl} H={H - fh} n={v.portas} /></g>
            </Box>
          </>
        ),
      };
    }
    case "gaveteiro":
    case "balcao":
      return { W: v.largura, H: v.altura, D: v.profundidade, el: <Box W={v.largura} H={v.altura} D={v.profundidade}><Drawers W={v.largura} H={v.altura} n={v.gavetas} /></Box> };
    case "canto_inferior":
    case "canto_superior":
    case "canto_roupa": {
      const A = v.lado_a, B = v.lado_b, Da = v.profundidade_a, Db = v.profundidade_b;
      const sw = Math.max(A, B) / 120;
      const rg = v.regua, aFront = v.porta_frente === 0, dt = 18;
      return {
        W: A, H: B, D: 0, noDim: true,
        el: (
          <g>
            <path d={`M0 0 L${A} 0 L${A} ${Da} L${Db} ${Da} L${Db} ${B} L0 ${B} Z`} fill={FACE} stroke={WOOD} strokeWidth={sw * 1.5} />
            <rect data-testid="l-corner-rail" x={sw} y={sw} width={rg} height={rg / 3} fill={ACC} />
            <rect x={sw} y={sw} width={rg / 3} height={rg} fill={ACC} opacity={0.6} />
            {v.portas !== 0 && <line data-testid="l-door-a" x1={A} y1={Da + (aFront ? dt : 0)} x2={aFront ? Db - dt : Db} y2={Da + (aFront ? dt : 0)} stroke={aFront ? "#FACC15" : ACC} strokeWidth={sw * 2} />}
            {v.portas !== 0 && <line data-testid="l-door-b" x1={Db + (aFront ? 0 : dt)} y1={B} x2={Db + (aFront ? 0 : dt)} y2={aFront ? Da : Da - dt} stroke={aFront ? ACC : "#FACC15"} strokeWidth={sw * 2} />}
            <LDims A={A} B={B} Da={Da} Db={Db} H={v.altura} regua={rg} box={tampBox(v)} />
          </g>
        ),
      };
    }
    case "nicho_inferior":
      return {
        W: v.largura, H: v.altura, D: v.profundidade,
        el: (
          <Box W={v.largura} H={v.altura} D={v.profundidade}>
            <rect x={18} y={18} width={v.largura - 36} height={v.altura - 36} fill={v.fundo_tipo === 2 ? "#0F1115" : "#1C2028"} />
            <Shelves W={v.largura} H={v.altura} n={v.prateleiras} />
            {v.portas > 0 && <g opacity={0.35}><Doors W={v.largura} H={v.altura} n={v.portas} /></g>}
          </Box>
        ),
      };
    case "nicho":
      return {
        W: v.largura, H: v.altura, D: v.profundidade,
        el: (
          <Box W={v.largura} H={v.altura} D={v.profundidade}>
            <rect x={18} y={18} width={v.largura - 36} height={v.altura - 36} fill={v.fundo ? "#1C2028" : "#0F1115"} />
            <Shelves W={v.largura} H={v.altura} n={v.prateleiras} />
          </Box>
        ),
      };
    case "ripado": {
      const rp = ripado(v);
      return { W: rp.W, H: rp.H, D: 0, el: <Ripado v={v} /> };
    }
    case "canto":
      return { W: v.comprimento, H: v.largura, D: 0, el: <Rounded L={v.comprimento} W={v.largura} r={Math.min(v.raio, Math.min(v.comprimento, v.largura) / 2)} corners={{ C1L1: !!v.C1L1, C1L2: !!v.C1L2, C2L1: !!v.C2L1, C2L2: !!v.C2L2 }} /> };
    case "rodape": {
      const n = Math.ceil(v.comprimento / 2700);
      const seg = v.comprimento / n;
      const H = Math.max(v.altura, v.comprimento / 8);
      return {
        W: v.comprimento, H, D: 0,
        el: (
          <g>
            <rect x={0} y={H - v.altura} width={v.comprimento} height={v.altura} fill={PANEL} stroke={ACC} strokeWidth={v.comprimento / 300} />
            {Array.from({ length: n - 1 }, (_, i) => (
              <line key={i} x1={seg * (i + 1)} y1={H - v.altura} x2={seg * (i + 1)} y2={H} stroke="#00E5FF" strokeWidth={v.comprimento / 300} strokeDasharray="20 10" />
            ))}
          </g>
        ),
      };
    }
    default:
      return { W: 100, H: 100, D: 0, el: null };
  }
}

const TAMP = "#22D3EE";

// box size once the tamponed faces are taken off the finished size
const tampBox = (v, W, H) => {
  if (!anyTamp(v)) return null;
  const e = v.tamp_esp || 0, vert = e * ((v.tamp_topo ? 1 : 0) + (v.tamp_base ? 1 : 0));
  if (v.lado_a != null) return { A: v.lado_a - (v.tamp_la ? e : 0), B: v.lado_b - (v.tamp_lb ? e : 0), H: v.altura - vert };
  return { W: W - e * ((v.tamp_le ? 1 : 0) + (v.tamp_ld ? 1 : 0)), H: H - vert };
};

// tamponed outer faces drawn as cyan bands (front view) or, on L corners (top view), the end laterals + dashed outline for top/base
function TampOverlay({ kind, v, W, H }) {
  if (!anyTamp(v)) return null;
  const b = Math.max(v.tamp_esp || 18, Math.max(W, H) / 70);
  if (kind.startsWith("canto_")) {
    const A = v.lado_a, B = v.lado_b, Da = v.profundidade_a, Db = v.profundidade_b, sw = Math.max(A, B) / 120;
    return (
      <g data-testid="preview-tampon" pointerEvents="none">
        {!!v.tamp_la && <rect data-testid="preview-tampon-la" x={A - b} y={0} width={b} height={Da} fill={TAMP} />}
        {!!v.tamp_lb && <rect data-testid="preview-tampon-lb" x={0} y={B - b} width={Db} height={b} fill={TAMP} />}
        {(!!v.tamp_topo || !!v.tamp_base) && <path data-testid="preview-tampon-tb" d={`M0 0 L${A} 0 L${A} ${Da} L${Db} ${Da} L${Db} ${B} L0 ${B} Z`} fill="none" stroke={TAMP} strokeWidth={sw * 1.2} strokeDasharray={`${sw * 4} ${sw * 3}`} />}
      </g>
    );
  }
  return (
    <g data-testid="preview-tampon" pointerEvents="none">
      {!!v.tamp_le && <rect data-testid="preview-tampon-le" x={-b} y={0} width={b} height={H} fill={TAMP} />}
      {!!v.tamp_ld && <rect data-testid="preview-tampon-ld" x={W} y={0} width={b} height={H} fill={TAMP} />}
      {!!v.tamp_topo && <rect data-testid="preview-tampon-topo" x={v.tamp_le ? -b : 0} y={-b} width={W + (v.tamp_le ? b : 0) + (v.tamp_ld ? b : 0)} height={b} fill={TAMP} />}
      {!!v.tamp_base && <rect data-testid="preview-tampon-base" x={v.tamp_le ? -b : 0} y={H} width={W + (v.tamp_le ? b : 0) + (v.tamp_ld ? b : 0)} height={b} fill={TAMP} />}
    </g>
  );
}

export const ModulePreview = ({ kind, values, testId = "module-preview", className = "" }) => {
  const { W, H, D, el, noDim } = Scene({ kind, v: values });
  const f = Math.max(W, H) / 22;
  const pad = Math.max(W, H) * 0.12;
  const top = D * 0.25 + (["banheiro", "balcao_inferior"].includes(kind) ? 20 : 0);
  const vb = `${-pad - f * 2} ${-top - pad} ${W + D * 0.35 + 2 * pad + f * 2} ${H + top + 2 * pad + f * 2}`;
  return (
    <svg data-testid={testId} viewBox={vb} className={className} preserveAspectRatio="xMidYMid meet">
      {el}
      <TampOverlay kind={kind} v={values} W={W} H={H} />
      {!noDim && <Dim W={W} H={H} D={D} box={tampBox(values, W, H)} />}
      {anyTamp(values) && <text data-testid="preview-tampon-legend" x={0} y={noDim ? H + pad * 0.75 : -top - pad / 3} fill={TAMP} fontSize={f * 0.8} fontFamily="JetBrains Mono">■ Tamponamento</text>}
    </svg>
  );
};
